import React from 'react';
import CustomMedia from 'util/custom-media-query';
import FormDialogrenderer from './FormDialogRenderer';
import i18n from 'i18n';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';
import Button from 'components/common/Button';
import TextField from 'components/common/TextField';
import {
  required,
  composeValidators,
} from 'validation/validators';

const DialogBody = ({
  form,
  renderType
}) => (
  <div className="form-body">
    <div className="fields-container">
      <React.Fragment>
        <TextField
          name="name"
          validate={value => composeValidators(required)(value)}
          label={i18n.t('orderAggregators:common:publish.name')}
          maxLength={50}
          placeholder={i18n.t(
            'orderAggregators:common:publish.namePlaceholder'
          )}
          required={true}
          notes={[i18n.t('orderAggregators:common:publish.nameNotes')]}
        />
      </React.Fragment>
    </div>
  </div>
);

const DialogFooter = ({ handleSubmit, invalid, close, renderType }) => (
  <div className="footer-btn-wrapper">
    {renderType === 'quotation' ? (
      <Button buttonType="B" type="button" onClick={handleSubmit} disabled={invalid}>
        {i18n.t('common:publish')}
      </Button>
    ) : (
      <Button
        buttonType="B"
        type="button"
        onClick={handleSubmit}
        disabled={invalid}
      >
        {i18n.t('common:publish')}
      </Button>
    )}
  </div>
);

class receiverDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      className,
      onSubmit,
      dialogRef,
      renderType
    } = this.props;

    return (
      <div className={className}>
        <FormDialogrenderer
          title={this.getTitle(renderType)}
          innerRef={dialogRef}
          dialogClassName="mini-dialog displayModal"
          renderBody={({ form }) => (
            <DialogBody
              form={form}
              renderType={renderType}
            />
          )}
          renderFooter={props => (
            <DialogFooter {...props} renderType={renderType} />
          )}
          onSubmit={onSubmit}
          showCloseAlert={false}
        />
      </div>
    );
  }

  /**
   * ダイアログのヘッダータイトルを取得
   */
  getTitle(renderType) {
    // 請求書：quotation、領収書：receipt
    if (renderType === 'quotation') {
      return i18n.t('orderAggregators:common:publish.quotationDialogTitle');
    }
    if (renderType === 'receipt') {
      return i18n.t('orderAggregators:common:publish.receiptDialogTitle');
    }
    return '';
  }
}

const commonStyle = css`
  .footer-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .form-body {
    padding: 0px 32px 0;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
`;

export default applyStyles(receiverDialog)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/PublishDialog.js